var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmarkChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17129 21.4284H14.8284C19.5427 21.4284 21.4284 19.5427 21.4284 14.8284V9.17129C21.4284 4.457 19.5427 2.57129 14.8284 2.57129H9.17129C4.457 2.57129 2.57129 4.457 2.57129 9.17129V14.8284C2.57129 19.5427 4.457 21.4284 9.17129 21.4284Z",
    fill: "#A020FF",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4349 15.7388C10.2349 15.7388 10.0449 15.6588 9.90492 15.5188L7.07492 12.6888C6.78492 12.3988 6.78492 11.9188 7.07492 11.6288C7.36492 11.3388 7.84492 11.3388 8.13492 11.6288L10.4349 13.9288L15.5749 8.78879C15.8649 8.49879 16.3449 8.49879 16.6349 8.78879C16.9249 9.07879 16.9249 9.55879 16.6349 9.84879L10.9649 15.5188C10.8249 15.6588 10.6349 15.7388 10.4349 15.7388Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkChecked);
export default __webpack_public_path__ + "static/media/CheckmarkChecked.436167045a29df8aceed6a49f9da0954.svg";
export { ForwardRef as ReactComponent };